<template>
  <article class="m-card-element m-card-element-design-5">
    <div class="m-card-element-info-data">
      <h5>
        {{ producto.categoria.nombre }}
      </h5>
      <h2 class="m-card-element-design-5-name">
        {{ producto.nombre }}
      </h2>

      <div class="m-card-element-design-5-assets-included">
        <div
          v-for="i in 4"
          :key="`img${i}`"
        >
          <img
            v-if="producto.metadata[`imagen${i}`]"
            :alt="producto.nombre"
            :id="`cardImg-${i}`"
            :src="producto.metadata[`imagen${i}`]"
          >
          <img
            v-else
            :alt="producto.nombre"
            :id="`cardImg-${i}`"
            src="@/assets/img/ds5.png"
          >
        </div>
      </div>
    <div class="m-card-element-info-state">
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="producto.activo"
          key="available"
        >
          DISPONIBLE
        </h3>
        <h3
          v-else
          key="notAvailable"
        >
          NO DISPONIBLE
        </h3>
        <h4
          v-if="producto.visible"
          key="visible"
        >
          VISIBLE
        </h4>
        <h4
          v-else
          key="hidden"
        >
          OCULTO
        </h4>
      </div>
    </div>
    </div>
  </article>
</template>
<script>
export default {
  name: 'MoleculeEditionBillingAcademyProductCard5',
  props: {
    producto: Object
  }
}
</script>
